/* folder.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.7 20.5" preserveAspectRatio="none">
        <path class="foreground-gl" d="M8.8,4.47A.56.56,0,0,1,9.36,5v.58c0,.27.19.49.61.49l11.09,0a1.15,1.15,0,0,1,1.16,1.15V18.12a1.16,1.16,0,0,1-1.16,1.16H1.78A1.15,1.15,0,0,1,.63,18.12V7.27A1.14,1.14,0,0,1,1.78,6.12h.94c.35,0,.51-.19.53-.42V5a.56.56,0,0,1,.56-.56h5"/>
        <path class="foreground-gl" d="M1.49,4a.23.23,0,0,0,.25-.2A1.24,1.24,0,0,1,3.11,2.54H9.32A1.25,1.25,0,0,1,10.7,3.78a.2.2,0,0,0,.21.21C13.5,4,21.15,4,21.15,4a2.45,2.45,0,0,1,1,.23V1.84a1,1,0,0,0-1-1H1.66a1,1,0,0,0-1,1V4.17A2,2,0,0,1,1.49,4Z"/>
        </svg>
    `
};
